<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 종류 -->
          <c-select
            type="search"
            codeGroupCd="SOP_PRE_WORK_CHECK_CLASS_CD"
            itemText="codeName"
            itemValue="code"
            name="sopPreWorkCheckClassCd"
            label="종류"
            v-model="searchParam.sopPreWorkCheckClassCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="작업 전 안전점검 항목 목록"
      tableId="workCheckItem"
      :columns="grid.columns"
      :data="grid.data"
      :filtering="false"
      :columnSetting="false"
      :editable="editable"
      @table-data-change="tableDataChange"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            :showLoading="false" 
            label="LBLADD" 
            icon="add" 
            @btnClicked="addPreWorkCheckItem" />
          <c-btn 
            v-if="editable" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="grid.data"
            mappingType="PUT"
            label="LBLSAVE" 
            icon="save" 
            @beforeAction="savePreWorkCheckItem"
            @btnCallback="savePreWorkCheckItemCallback"/>
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'preWorkCheckItem',
  data() {
    return {
      searchParam: {
        plantCd: null,
        sopPreWorkCheckClassCd: null,
        useFlag: 'Y',
      },
      grid: {
        columns: [],
        data: [],
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      classItems: [],
      editable: true,
      listUrl: '',
      listClassUrl: '',
      saveUrl: '',
      isSave: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.pwc.item.list.url
      this.listClassUrl = selectConfig.sop.pwc.class.list.url
      this.saveUrl = transactionConfig.sop.pwc.item.save.url
      // code setting
      // list setting
      this.setHeader();
      this.getList();
    },
    setHeader() {
      /**
       * 요기부터 진행
       */
      this.$http.url = this.listClassUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.classItems = _result.data;
        this.grid.columns = [
          {
            name: 'plantCd',
            field: 'plantCd',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            required: true,
            style: 'width:100px',
            type: 'plant',
          },
          {
            name: 'sopPreWorkCheckClassName',
            field: 'sopPreWorkCheckClassName',
            label: '종류',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'sopPreWorkCheckClassId',
            field: 'sopPreWorkCheckClassId',
            label: '점검 구분명',
            align: 'center',
            sortable: true,
            required: true,
            style: 'width:150px',
            type: 'select',
            itemText: 'checkClassName',
            itemValue: 'sopPreWorkCheckClassId',
            comboItems: this.classItems,
          },
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목명',
            align: 'left',
            sortable: true,
            required: true,
            style: 'width:450px',
            type: 'text',
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            sortable: true,
            style: 'width:100px',
            type: 'check',
            true: 'Y',
            false: 'N',
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: 'LBLSORTORDER',
            align: 'center',
            style: 'width:100px',
            sortable: true,
            type: 'number',
          },
        ]
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    addPreWorkCheckItem() {
      if (!this.grid.data) {
        this.grid.data = [];
      }
      this.grid.data.splice(0, 0, {
        sopPreWorkCheckItemId: uid(),  // 작업 전 안전점검항목 일련번호
        sopPreWorkCheckClassId: null,  // 작업 전 안전점검 구분 일련번호
        sopPreWorkCheckClassCd: '', // 작업 전 안전점검 구분
        sopPreWorkCheckClassName: '', // 작업 전 안전점검 구분
        checkClassName: '', // 점검 구분명
        plantCd: null,  // 사업장 코드
        checkItemName: '',  // 점검항목명
        useFlag: 'Y',  // 사용여부
        sortOrder: 0,  // 순번
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        editFlag: 'C'
      })
    },
    tableDataChange(props, col) {
      if (col.name === 'sopPreWorkCheckClassId') {
        if (props.row[col.name]) {
          let classData = this.$_.find(this.classItems, { sopPreWorkCheckClassId: props.row[col.name] });
          if (classData) {
            this.$set(props.row, 'sopPreWorkCheckClassCd', classData.sopPreWorkCheckClassCd)
            this.$set(props.row, 'sopPreWorkCheckClassName', classData.sopPreWorkCheckClassName)
            this.$set(props.row, 'checkClassName', classData.checkClassName)
          }
        } else {
          this.$set(props.row, 'sopPreWorkCheckClassCd', '')
          this.$set(props.row, 'sopPreWorkCheckClassName', '')
          this.$set(props.row, 'checkClassName', '')
        }
      } else {
        // nothing...
      }
    },
    savePreWorkCheckItem() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    savePreWorkCheckItemCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
  }
};
</script>
